const regexes = {
  Alphabet: /^[a-z]+(([-']|\s)?[a-z]+)*$/i,
  AlphabetOnly: /^[a-z]+(([-'])?[a-z]+)*$/i,
  AlphabetTwoSpace: /^([a-z]+[-']*[a-z]+(\s(?!$))?){1,2}([a-z]+[-']*[a-z]+)*?$/i,
  AlphabetSpecial: /^[a-z]+[!#%&'*+-/=?^_`{|}~]+(([-']|\s)?[a-z]+[!#%&'*+-/=?^_`{|}~]]+)*$/i,
  AlphabetNumeric:
    /^((^[a-z]{2}\.\s)?((\w|\w')\s[a-z]{2}\.\s)?([a-z0-9]+-[a-z0-9]+)?([0-9]\/[0-9]{0,2})?([a-z]{1}'[a-z]+|\s[a-z]{1}'[a-z]+|[a-z]'\s[a-z]+|[a-z]'[s]\s[a-z]+)*([a-z0-9]+\s{0,1})?)+(\w{2,}'|[\w]|\w{2,}'[s])$/i,
  AlphanumericPunctuation: /^([a-z0-9\-_,./£$?!&:]*)$/i,
  Email:
    /^([-a-z0-9!$%&*_/=+#}{'?|]+(\.[-a-z0-9!$%&*_/=+#}{'?|]+)*)@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]+)$/i,
  Numeric: /^[0-9]+$/,
  Amount: /^[0-9]+$/,
  /**
   * @hotfix
   * @todo
   *
   * There is a data issue that effects some existing customers, where their phone number is stored
   * with the international country code replacing the '0' part of their area code.
   *
   * Because existing customers are not meant to be able to edit their phone number, this will
   * trigger validation warnings they cannot progress from, without calling our contact centre to
   * edit the number.
   *
   * To mitigate this, we are using an alternate regex to validate phone numbers, ensuring still
   * that the number is either a valid 01, 02 or 07 number, but also allowing a valid 44 number.
   *
   * We've also removed the length validation that occurs in (filename here?) as the regex will
   * enforce the expected length of valid phone numbers itself, it just doesn't match the regex
   * that's defined in the Global Behaviours document.
   *
   * Regex Explainer:
   *
   * the ^ and $ chars at the start/end of each group enforce an exact match of the whole string,
   * rather than just accepting a match that might occur within the string.
   *
   * Changing {9} to {9,9} or {10,10} lets us enforce an expected range.
   * The phone number cannot have more-or-less-than 9 (or 10) characters after the respective 0/44
   * prefix.
   *
   * Mobile numbers may also be formatted by the backend to start with 44, so adjustments have been
   * made to that regex as well.
   *
   * The previous regex used for Phone Numbers was:
   * Phone: /(01)\d{9}|(02)\d{9}|(07)\d{9}/,
   * Mobile: /^(07[\d]{9})$/
   */
  Phone: /^(01)\d{9,9}$|^(02)\d{9,9}$|^(07)\d{9,9}$|^(44)\d{10,10}$/,
  Mobile: /^(07[\d]{9,9})$|^(447){9,9}$/,
  PostCode:
    /^((GIR 0AA|X9 9RB|X9 9AA|X9 9BF|X9 9AJ|X9 9AB|X9 9TA|X9 9LG|X9 9BH|X9 9LF|X9 2TR|XE16 4QZ|XE11 1AA|XE98 1TL|XEP O11|XE99 3GG|XE0 2AQ|XE1A 1AA|XE18 3AN|XE7 4GJ|XE1P 2PR|XE2 7EJ|XE12 8JS|XE1H 9DW|XE 5GG|XE1X 7XA|XE1X 7XF|XE1 8NH|XE1 1RJ|XE1 1RN|XE1 1LE|XE24 99X|XE 0AA|XE12 8HJ)|((([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) [0-9][A-Z]{2}))$/i
};

function getRegEx(type) {
  return regexes[type];
}

function formatPostCode(postCode) {
  const postcodeMatch = postCode.toUpperCase().match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})$/);

  if (postcodeMatch) {
    return postcodeMatch.shift().join(' ');
  }

  return postCode;
}

function isValidInput(value, type) {
  const pattern = new RegExp(getRegEx(type));
  const valueToTest = type === 'PostCode' ? formatPostCode(value) : value;

  return pattern.test(valueToTest);
}

export { isValidInput };
